export type AvailableLocales = 'fr' | 'en'

export function parseLocale(locale: string): AvailableLocales {
  if (locale !== 'fr' && locale !== 'en') {
    throw new Error(`Unrecognized locale: ${locale}`)
  }

  return locale
}

const availableLocales: AvailableLocales[] = ['fr', 'en']

export function isAvailableLocale(value: string): value is AvailableLocales {
  return availableLocales.includes(value as AvailableLocales)
}
